<ion-select [value]="dataRange[0].value" (ionChange)="dateRangeChanged($event.detail.value)">
  <ion-select-option *ngFor="let date of dataRange" [value]="date.value">{{date.label}}</ion-select-option>
</ion-select>
